<template>
  <div>
    <tci-about-us :title="$t('about.award')">
      <v-timeline :dense="isMobile" :class='isMobile?"":"px-12"'>
        <v-timeline-item 
          v-for="(timeline, i) in $t('about.award_timelines')"
          :key="i"
          :class='!isMobile&&i%2==1?"text-right":"text-left"'
          small
          color="#15283D"
          fill-dot  
        >
          <template v-slot:opposite>
            <span
              class="headline font-weight-bold"
              v-text="timeline.year"
            ></span>
          </template>
          <v-card class="elevation-2">
            <v-card-title v-if=isMobile>
              {{ timeline.year }}
            </v-card-title>
            <v-card-text>
              {{ timeline.content }}
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
      <v-row>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-img :width='isMobile?"":"400"' src="../assets/award/p1.jpg"></v-img>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-row>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-img  :width='isMobile?"":"400"' src="../assets/award/p2.jpg"></v-img>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-row>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-img :width='isMobile?"":"400"' src="../assets/award/p3.jpg"></v-img>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-row>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-img :width='isMobile?"":"400"' src="../assets/award/p4.jpg"></v-img>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
    name: 'CompanyAward',
    components: {
    "tci-about-us": TciAboutUs,
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    timelines: 
    [{"year":"2008","content":"大宇宙（中国）入选2007年中国软件出口（外包）10强"},
    {"year":"2009","content":"通过ISO27001认证"},
    {"year":"2010","content":"通过CMMI3级认证"},
    {"year":"2010","content":"获得江苏省软件企业认定"},
    {"year":"2010","content":"获得技术先进型服务企业认定"},
    {"year":"2011","content":"获得国家高新技术企业认定"},
    {"year":"2011-2012","content":"年度中国最佳外包服务商"},
    {"year":"2012-2013","content":"transcosmos group位居中国「BPO TOP20」第3位"},
    {"year":"2014","content":"transcosmos荣获IAOP(国际外包专业协会)全球外包100强中13位"},
    {"year":"2016","content":"苏州工业园区AA级劳动保障信用等级单位"},
    {"year":"2017","content":"苏州市服务贸易创新发展重点企业"},
    {"year":"2017","content":"获得苏南国家自主创新示范区瞪羚企业"},
    {"year":"2018","content":"获得苏州工业园区瞪羚企业称号"}],
    isMobile: false
  }),
  mounted() {
  this.isMobile = this.$vuetify.breakpoint.xs;
}
}

</script>
